export const MEXICO_CENTER: [number, number] = [23.6345, -102.5528];
export const DEFAULT_ZOOM = 5;
export const MAX_ZOOM = 18;
export const FIT_BOUNDS_MAX_ZOOM = 12;

// CARTO keys are intended to be used by the browser. Configure the key for
// each deployment through VITE_CARTO_BASEMAP_KEY; never commit its value.
const CARTO_BASEMAP_KEY = import.meta.env.VITE_CARTO_BASEMAP_KEY?.trim();

function cartoTiles(style: 'dark_all' | 'light_all'): string {
  const baseUrl = `https://{s}.basemaps.cartocdn.com/${style}/{z}/{x}/{y}{r}.png`;
  return CARTO_BASEMAP_KEY
    ? `${baseUrl}?key=${encodeURIComponent(CARTO_BASEMAP_KEY)}`
    : baseUrl;
}

export const DARK_TILES = cartoTiles('dark_all');
export const LIGHT_TILES = cartoTiles('light_all');

export const TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>';

// Support both VITE_API_URL and VITE_API_BASE_URL for backwards compatibility
// Default to empty string (relative URLs) for same-domain deployments
export const API_BASE_URL = import.meta.env.VITE_API_URL 
  || import.meta.env.VITE_API_BASE_URL 
  || '';  // Empty string uses relative URLs (same domain)

export const STORAGE_KEYS = {
  TOKEN: 'ares_token',
  TOKEN_EXPIRES: 'ares_token_expires',
  USER: 'ares_user',
  SESSION_ID: 'ares_session_id',
  THEME: 'ares_theme',
  SIDEBAR_WIDTH: 'ares_sidebar_width',
  SESSION_DURATION: 'ares_session_duration',
} as const;

export const DEFAULT_SIDEBAR_WIDTH = 300;
export const MIN_SIDEBAR_WIDTH = 250;
export const MAX_SIDEBAR_WIDTH = 600;

export const DEFAULT_FLEET_PANEL_HEIGHT = 450;
export const MIN_FLEET_PANEL_HEIGHT = 150;
export const MAX_FLEET_PANEL_HEIGHT = 0.8; // Percentage of window height

export const CHART_COLORS = [
  'rgba(59, 130, 246, 0.6)',
  'rgba(16, 185, 129, 0.6)',
  'rgba(239, 68, 68, 0.6)',
  'rgba(245, 158, 11, 0.6)',
  'rgba(139, 92, 246, 0.6)',
];

export const CHART_BORDER_COLORS = [
  'rgba(59, 130, 246, 1)',
  'rgba(16, 185, 129, 1)',
  'rgba(239, 68, 68, 1)',
  'rgba(245, 158, 11, 1)',
  'rgba(139, 92, 246, 1)',
];

export const POI_TYPES = ['caseta', 'gasolinera', 'poi_marker', 'poi'] as const;
